import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { RouteNames } from "../routes";

export const PageNotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="not-found">
            <span className="not-found__code">404</span>
            <h1 className="page-header__heading">{t("page.notFound.title")}</h1>
            <Button
                className="mt-xs"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(`/${RouteNames.organizations}`)}
            >
                {t("actions.back")}
            </Button>
        </div>
    );
}
